<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Ian Taylor writes about an Egyptian girl who becomes a queen due to her goddess. The cat goddess based in ancient Egypt and being reborn in Victorian times.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1233309d